/* eslint semi:0 */
import { getLeagueNames, getLeagueId2Name, } from './leagueTransformUtil'
import { transformMatchResponse, } from './matchTransformUtil'
import { flatten, } from '../../jsCore/utils/array'


function mapCurrentDayLeagueToCurrentDayLeagueMatches(currDayLeague){
  const { league_id: leagueId, matches: currDayLeagueMatches, } = currDayLeague
  return currDayLeagueMatches.map(match => ({ match, leagueId, }))
}

function mapDayToListOfLeagues({ day_matches: currDayLeaguesList, }){
  return currDayLeaguesList.map(mapCurrentDayLeagueToCurrentDayLeagueMatches)
}

function getFlatMatchesArray({ matches: listOfDays, }){
  return flatten(listOfDays.map(mapDayToListOfLeagues))
}

function reduceMatchesByLeagues(leagueName2LeagueData, currMatch){
  const { leagueId, match, } = currMatch
  const leagueId2Name = getLeagueId2Name()
  const leagueName = leagueId2Name[leagueId]
  let leagueData = leagueName2LeagueData[leagueName]
  if (!leagueData) {
    leagueData = {
      name: leagueName,
      id: leagueId,
      matches: [],
    }
    leagueName2LeagueData[leagueName] = leagueData
  }
  leagueData.matches.push(transformMatchResponse(match))
  return leagueName2LeagueData
}

export function transformMatchResponseToHomepageSchedule(matchesData){
  const flatMatchesArray = getFlatMatchesArray(matchesData)
  const leagues = flatMatchesArray.reduce(reduceMatchesByLeagues, {})
  return {
    matches: {
      leagues,
      leagueNamesForSelection: getLeagueNames(),
    },
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/schedule/scheduleHomepageTransformUtil.js